import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RTooltip,
  ResponsiveContainer, LineChart, Line, Legend
} from "recharts";

export default function Reports() {
  const [conv, setConv] = useState([]);
  const [attend, setAttend] = useState([]);
  const [fees, setFees] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/reports/conversion"),
      api.get("/reports/attendance-by-class"),
      api.get("/reports/fee-collection"),
    ]).then(([c, a, f]) => {
      setConv(c.data); setAttend(a.data); setFees(f.data);
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl font-black">Reports</h1>
        <p className="text-muted-foreground font-medium">Big picture stories, one glance.</p>
      </header>

      <Card className="rounded-3xl">
        <CardHeader><CardTitle className="text-xl font-extrabold">Enquiry → Admission Conversion</CardTitle></CardHeader>
        <CardContent className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={conv}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="month" tick={{ fontSize: 12, fontWeight: 600 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <RTooltip />
              <Legend />
              <Line type="monotone" dataKey="rate" stroke="hsl(142 52% 43%)" strokeWidth={3} dot={{ r: 5 }} name="Conversion %" />
              <Line type="monotone" dataKey="total" stroke="hsl(187 71% 55%)" strokeWidth={2} dot={{ r: 4 }} name="Total enquiries" />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="rounded-3xl">
        <CardHeader><CardTitle className="text-xl font-extrabold">Attendance by Class (last 30 days)</CardTitle></CardHeader>
        <CardContent className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={attend}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="class" tick={{ fontSize: 12, fontWeight: 600 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <RTooltip />
              <Bar dataKey="attendance_pct" fill="hsl(187 71% 55%)" radius={[10, 10, 0, 0]} name="Attendance %" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="rounded-3xl">
        <CardHeader><CardTitle className="text-xl font-extrabold">Fee Collection %</CardTitle></CardHeader>
        <CardContent className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={fees}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="month" tick={{ fontSize: 12, fontWeight: 600 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <RTooltip />
              <Legend />
              <Bar dataKey="collected" fill="hsl(142 52% 55%)" radius={[10, 10, 0, 0]} name="Collected ₹" />
              <Bar dataKey="pending" fill="hsl(340 82% 72%)" radius={[10, 10, 0, 0]} name="Pending ₹" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
}
